<div class="dropdown dropdown-end">
  <button tabindex="0" class="btn btn-ghost btn-circle text-primary-content">
    <span class="material-icons-outlined text-2xl">account_circle</span>
  </button>
  <ul tabindex="0" class="dropdown-content menu bg-base-100 rounded-box z-50 w-52 p-2 shadow text-base-content">
    <li class="pointer-events-none opacity-60">
      <span>
        <span class="material-icons-outlined text-base">person</span>
        {{ userName }}
      </span>
    </li>
    <li>
      <a>
        <span class="material-icons-outlined text-base">account_box</span>
        {{ 'PROFILE' | translate }}
      </a>
    </li>
    @if (canChangePassword) {
      <li>
        <button (click)="openPasswordChangeDialog()">
          <span class="material-icons-outlined text-base">lock_reset</span>
          {{ 'RESET_PASSWORD' | translate }}
        </button>
      </li>
    }
    <li>
      <button (click)="logout()">
        <span class="material-icons-outlined text-base">exit_to_app</span>
        {{ 'LOGOUT' | translate }}
      </button>
    </li>
  </ul>
</div>

<app-password-change #passwordChangeModal></app-password-change>
